(function(){
'use strict';

/**
 * @name scSlugify
 * @kind filter
 */

function scSlugify() {
  return function (input) {
    return window.getSlug(input, {
      custom: {
        "'": '',
        '"': ''
      },
      maintainCase: true
    }) || '-';
  };
}

angular.module('classy').filter('scSlugify', scSlugify);
})();